import { render, staticRenderFns } from "./portal_announce.vue?vue&type=template&id=7e9fcf69&scoped=true&"
import script from "./portal_announce.vue?vue&type=script&lang=js&"
export * from "./portal_announce.vue?vue&type=script&lang=js&"
import style0 from "./portal_announce.vue?vue&type=style&index=0&id=7e9fcf69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e9fcf69",
  null
  
)

export default component.exports